var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24.193 24.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "usd-circle",
    d: "M12.1,8a12.1,12.1,0,1,0,12.1,12.1A12.095,12.095,0,0,0,12.1,8Zm0,22.632A10.536,10.536,0,1,1,22.632,20.1,10.548,10.548,0,0,1,12.1,30.632Zm1.966-10.794-3.512-.985a1.352,1.352,0,0,1,.385-2.658h2.195a2.491,2.491,0,0,1,1.493.493.387.387,0,0,0,.507-.039l.551-.561a.392.392,0,0,0-.039-.585,4.024,4.024,0,0,0-2.517-.873h-.249V12.678a.391.391,0,0,0-.39-.39h-.78a.391.391,0,0,0-.39.39v1.951h-.38a2.913,2.913,0,0,0-.81,5.722l3.512.985a1.352,1.352,0,0,1-.385,2.658H11.058A2.491,2.491,0,0,1,9.565,23.5a.387.387,0,0,0-.507.039l-.551.561a.392.392,0,0,0,.039.585,4.024,4.024,0,0,0,2.517.873h.254v1.951a.391.391,0,0,0,.39.39h.78a.391.391,0,0,0,.39-.39V25.56h.38a2.912,2.912,0,0,0,.8-5.722Z",
    transform: "translate(0 -8)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdCircle);
export default __webpack_public_path__ + "static/media/usd-circle.5d854b329c2d9e7b66ec3c2b83550be2.svg";
export { ForwardRef as ReactComponent };